import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconFormsCircleSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFormsCircleSquare"><Path d="M17.75 8.75C19.1307 8.75 20.25 9.86929 20.25 11.25V17.25C20.25 18.9069 18.9069 20.25 17.25 20.25H11.25C9.86929 20.25 8.75 19.1307 8.75 17.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="9" cy="9" r="6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFormsCircleSquare;
